<template>
    <BaseNotification theme="info" hide-dismiss :text="t('moments.empty.noActiveMoments')" class="mb-10 mx-auto max-w-200" />
</template>

<script setup lang="ts">
import BaseNotification from "~vue/components/BaseNotification.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
